<template>
  <div id="production-table">
    <v-data-table :items="filteredOrders" :headers="headers">
      <template v-slot:item.dateCreated="{ item }">
        {{ $moment.unix(item.dateCreated.seconds).format('Do MMM YYYY') }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip location="top" :open-delay="500">
          <template v-slot:activator="{ props }">
            <v-icon @click="checkShipments(item)" v-bind="props" size="small">mdi-wrench</v-icon>
          </template>
          <span>Check Shipment</span>
        </v-tooltip>
        <v-tooltip location="top" :open-delay="500">
          <template v-slot:activator="{ props }">
            <v-icon @click="markShipmentsCreated(item)" v-bind="props" class="mx-1">mdi-check-bold</v-icon>
          </template>
          <span>Mark Shipments As Created</span>
        </v-tooltip>
        <v-tooltip location="top" :open-delay="500">
          <template v-slot:activator="{ props }">
            <v-icon @click="manuallyCreateShipments(item)" v-bind="props">mdi-plus-thick</v-icon>
          </template>
          <span>Manually Create Shipments</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { db, functions } from '@/js/db'
import { collection, doc, getDocs, query, updateDoc, where } from 'firebase/firestore'
import { httpsCallable } from 'firebase/functions'

export default {
  name: 'MissingShipments',
  data() {
    return {
      missingShipments: [],
      headers: [
        {
          title: 'Order #',
          sortable: false,
          width: 100,
          key: 'orderNumber'
        },
        {
          title: 'Customer',
          key: 'customerContactDetails.email'
        },
        {
          title: 'Creator',
          key: 'creatorEmail'
        },
        {
          title: 'Date Created',
          key: 'dateCreated'
        },
        {
          title: 'Region',
          key: 'region'
        },
        {
          title: 'Type',
          key: 'type'
        },
        {
          title: 'Actions',
          key: 'actions',
          align: 'end',
          sortable: false
        }
      ]
    }
  },
  created() {
    this.$live(
      'missingShipments',
      query(
        collection(db, 'orders'),
        where('type', '==', 'mega-admin'),
        where('shipmentsCreated', '==', false),
        where('region', '!=', 'us')
      )
    )
  },
  computed: {
    filteredOrders() {
      return this.missingShipments.filter((o) => {
        return !(o.foc == false && o.numPayments == 0)
      })
    }
  },
  methods: {
    async checkShipments(order) {
      const shipments = await getDocs(query(collection(db, 'shipments'), where('orderID', '==', order.id)))
      this.$store.commit('openSnackbar', {
        snackbarText: 'Number of Shipments: ' + shipments.docs.length
      })
    },
    async markShipmentsCreated(order) {
      await updateDoc(doc(db, 'orders', order.id), {
        shipmentsCreated: true
      })
    },
    async manuallyCreateShipments(order) {
      try {
        const manuallyCreateShipmentsFunc = httpsCallable(functions, 'manuallyCreateShipmentsFromOrderID')
        await manuallyCreateShipmentsFunc(order.id)
      } catch (e) {
        this.$store.commit('openSnackbar', {
          snackbarText: 'Error:' + e.message
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#production-table {
  width: 100%;
}
</style>
